;
define("product_line_stock.tpl", function(){});

